import React, {Component} from 'react';
import { Row, Col, Icon, Spin } from 'antd/lib/index';
import {loadAttachmentFiles} from '../../actions/interview';
import {connect} from "react-redux";
import {Scrollbars} from "react-custom-scrollbars";
import {getByAccounts} from "../../actions/topicSelection";
import {STATUTS_MAP} from "./topicSelectionList";
import UploadWall from "../upload/UploadWall";
import {ATTCHMENT_TYPE, PIC_TYPE} from "../../constants";
import {applicationName, getSubffix, uuid} from "../../utils";
import ChunkUpload from "../upload/ChunkUpload";

class TopicSelectionBaseInfo extends Component {

    constructor(props){
        super(props);
        this.state = {
            data:{},
            loadFileIds:false,//是否已经加载了附件
            files:[],
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            loadFileIds:false,
        });
        loadAttachmentFiles(nextProps.data.tsFileIds, (res)=>{
            this.setState({
                loadFileIds:true,
                files: res
            })
        });
        this.loadUser(nextProps.data);
    }

    componentWillMount() {
        this.initFileIds();
        this.loadUser(this.props.data);
    }

    initFileIds = ()=>{
        loadAttachmentFiles(this.props.data.tsFileIds, (res)=>{
            this.setState({
                loadFileIds:true,
                files: res
            })
        });
    };

    users = [];//这里做一个缓存，免得每次都去查询

    loadUser(data){
        let accounts = [];
        data.tsCreateBy && data.tsCreateBy.map(account =>{
            let isAdd = true;
            this.users.map(user=>{
                if(user && (user.account === account)){
                    isAdd = false;
                }
            });
            isAdd && (accounts.indexOf(account)===-1) && accounts.push(account);
        });


        data.tsAppointee && data.tsAppointee.map(account =>{
            let isAdd = true;
            this.users.map(user=>{
                if(user && (user.account === account)){
                    isAdd = false;
                }
            });
            isAdd && (accounts.indexOf(account)===-1) && accounts.push(account);
        });

        (accounts.length > 0) && getByAccounts(accounts.join(",")).then(userList=>{
            userList && userList.map(_user=>{
                let isAdd = true;
                this.users && this.users.map(user=>{
                    if(_user && user && _user.account && user.account ){
                        (_user.account === user.account) && (isAdd = false)
                    }
                });
                isAdd && this.users.push(_user);
            });
            this.setState({});
        })
    }

    renderUserNames (accounts){
        let name=this.props.currentUser.name;
        accounts && accounts.map((account,index)=>{
            if(name===account){
                accounts.splice(index,1);
                accounts.unshift(name)
            }
        });
        return accounts.join(",");
    }

    renderAssignUserNames(accounts){
        let userNames = [];
        this.users && this.users.map(user=>{
                let find = false;
                accounts && accounts.map(account=>{
                    user && (user.account === account) && (find = true);
                });
                find && userNames.push(user.name);
        });
        return userNames.join(",");
    }

    render() {
        return (
            <div style={{backgroundColor:"#f4f6fc",padding:"20px",width:"100%"}}>
                <Scrollbars
                    autoHeight
                    autoHeightMax={600}
                >
                    <div style={{width:"100%", backgroundColor:"#fff", padding:"32px 40px"}}>
                        <Row gutter={40}>
                            <Col span={8}><TextInfo title={"选题名称"} desc={this.props.data.tsName}/></Col>
                            <Col span={8}><TextInfo title={"涉及单位"} desc={this.props.data.tsCompany}/></Col>
                            <Col span={8}><TextInfo title={"联系人"} desc={this.props.data.tsContactsName}/></Col>
                        </Row>
                        <Row gutter={40} style={{marginTop:"16px"}}>
                            <Col span={8}><TextInfo title={"联系方式"} desc={this.props.data.tsContactsPhone}/></Col>
                            <Col span={8}><TextInfo title={"提交时间"} desc={window.formatDate(this.props.data.tsCreateTime)}/></Col>
                            <Col span={8}><TextInfo title={"创建人"} desc={this.renderUserNames(this.props.data.tsCreateByName)}/></Col>
                        </Row>
                        <Row gutter={40} style={{marginTop:"16px"}}>
                            <Col span={8}><TextInfo title={"选题状态"} desc={STATUTS_MAP["type_"+this.props.data.tsStatus].name}/></Col>
                            <Col span={8}><TextInfo title={this.props.data.tsStatus<3?'预指派':'指派给'} desc={this.renderAssignUserNames(this.props.data.tsAppointee)}/></Col>
                            <Col span={8}>
                            </Col>
                        </Row>
                        <Row style={{marginTop:"16px"}}>
                            <Col span={24}><TextInfo title={"选题内容"}
                                                     desc={this.props.data.tsContent}/></Col>
                        </Row>
                        <Row style={{marginTop:"16px"}}>
                            {this.state.loadFileIds?<Col span={24}>
                                    <FileInfo title={"附件"} files={this.state.files}/>
                                </Col>:
                                <Col span={24} style={{textAlign: "center"}}>
                                    <Spin />
                                </Col>}
                        </Row>
                    </div>
                </Scrollbars>
            </div>
        );
    }
}

TopicSelectionBaseInfo.defaultProps = {
    data: {
        tsName:"",
        tsCompany:"",
        tsContactsName:"",
        tsContactsPhone:"",
        tsCreateTime:"",
        tsCreateBy:[],
        tsStatus:"",
        tsFileIds:[],
        tsAppointee:[],
        tsContent:[]
    },
    tsAppointeeChange:()=>{}
};

class TextInfo extends Component{
    render() {
        return <div style={{width:"100%"}}>
            <div style={{fontSize: "14px",color: "#6c748b", marginBottom:"16px"}}><b>{this.props.title}</b></div>
            <div style={{fontSize: "14px",color: "#808eb5"}}>{this.props.desc}</div>
        </div>
    }
}

class FileInfo extends Component{
    render() {
        if(!this.props.files || this.props.files.length === 0 ){
            return <div></div>
        }
        return <div style={{width:"100%"}}>
            <div style={{fontSize: "14px",color: "#6c748b", }}><b>{this.props.title}</b></div>
            <UploadWall
                accept={"."+[...PIC_TYPE, ...ATTCHMENT_TYPE].join(",.")}
                multiple={true}
                action="/cm-sites-pms/index/uploadFile"
                listType="picture-card"
                fileList={(()=>{
                    let fileList = [];
                    this.props.files && this.props.files.map(attachment=>{
                        fileList.push({
                            uid: uuid(),
                            ...attachment,
                            status: 'done',
                            path : attachment.url,
                            ext: getSubffix(attachment.name),
                        })
                    });
                    return fileList;
                })()}
                customRequest={new ChunkUpload({
                    checkFileURL:"/cm-sites-"+applicationName()+"/index/checkFile",
                    checkChunkURL:"/cm-sites-"+applicationName()+"/index/checkChunk",
                    uploadChunkURL:"/cm-sites-"+applicationName()+"/index/uploadChunks",
                    chunkUploadOverURL:"/cm-sites-"+applicationName()+"/index/chunkUploadOver",
                    mergeChunksURL:"/cm-sites-"+applicationName()+"/index/mergeChunks"
                }).start}
                icons={(()=>{
                    let res = ["download"];
                    return res;
                })()}
                uploadBtnName={""}
                showUploadBtn={ false}
                onDownload={(file)=>{
                    if(file.path.indexOf("?") === -1){
                        window.location.href = file.path + "?download=1";
                    }else{
                        window.location.href = file.path + "&download=1";
                    }
                }}
                style={{padding:"0px"}}
            />
            {/*<div style={{fontSize: "14px",color: "#808eb5"}}>*/}
            {/*{*/}
            {/*    this.props.files.map((item, index)=>{*/}
            {/*        return (*/}
            {/*            <div key={index} style={{marginTop:16,float:'left'}}>*/}
            {/*                <File name={item.name} path={"images/folder.png"} url={item.url}*/}
            {/*                                   style={{float: "left", marginLeft:(index+1)%6===1?0:20}}/>*/}
            {/*            </div>*/}
            {/*        )*/}

            {/*    })*/}
            {/*}*/}
            {/*<div style={{clear:'both'}}/>*/}
            {/*</div>*/}
        </div>
    }
}
class File extends Component{

    state = {
        shade: false
    };

    formatName = (name)=>{
        let maxLength = 16;
        if(name.length >= maxLength){
            return name.substring(0, maxLength - 1) + "...";
        }
        return name;
    };

    render() {
        return <div onMouseOver={(e)=>{this.setState({shade:true})}} onMouseOut={(e)=>this.setState({shade: false})} className={this.props.className} style={{width:"120px", height:"120px", backgroundColor: "#f4f6fc", borderRadius: "6px", position:"relative", ...this.props.style}}>
            {/*<img src={this.props.path} style={{position:"absolute", top:"32px", left:"44px"}} width={32} height={36}/>*/}
            <Icon type="file" style={{position:"absolute", top:"32px", left:"44px", fontSize:"32px"}} />
            <div style={{margin:"auto", marginTop:"78px", textAlign:"center"}}>{this.formatName(this.props.name)}</div>
            <div style={{width:"100%", height:"100%",textAlign:"center", backgroundColor:"#000000a6",position:"absolute",top:"0px",display:this.state.shade?"block":"none"}}>
                <Icon type={"download"} onClick={()=>{
                    if(this.props.url.indexOf("?") === -1){
                        window.location.href = this.props.url + "?download=1";
                    }else{
                        window.location.href = this.props.url + "&download=1";
                    }
                }} style={{marginTop:"44px",color:"#fff",fontSize:20}}/>
            </div>
        </div>
    }
}
File.defaultProps={
    style:{},
    className: ""
};

function mapStateToProps(state){
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps)(TopicSelectionBaseInfo);